import classNames from 'classnames/bind';
import { DateFormat, DurationMap } from 'common/types';
import { days, isStayDuration } from 'common/utils';
import {
  SearchType,
  SeatClass,
  TripType,
  getSeatClassMap,
  tripTypes,
} from 'contexts/searchParams';
import { IFlightSearchHistory } from 'hooks/useHistory';
import styles from './index.module.scss';

const cx = classNames.bind(styles);

interface IProps {
  history: IFlightSearchHistory;
}

const ScheduleInfo = ({ history }: IProps) => {
  const { adult, child, infant } = history.passenger;
  const seatClasses = getSeatClassMap(
    history.searchType === SearchType.DOMESTIC,
  );
  return (
    <>
      <time className={cx('time')}>
        {history?.tripList
          .map(({ departureDate }, index) =>
            index === 1 && isStayDuration(departureDate)
              ? DurationMap.get(departureDate)
              : days(departureDate, DateFormat.YMD).format(DateFormat.DotMDd),
          )
          .join(' ~ ')}
        &nbsp; ({tripTypes.get(history.trip as TripType)})
      </time>
      &nbsp; / 성인 {adult}
      {!!child && `, 소아 ${child}`}
      {!!infant && `, 유아 ${infant}`}
      {', '}
      {seatClasses.get(history.fareType as SeatClass)}
    </>
  );
};

export default ScheduleInfo;
